// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"d2bbc78f","846":"3a29f8b5"}[chunkId] + ".chunk.js";
};